import React from 'react';
import _ from 'lodash';
import { Col, Row } from 'antd';
import LayoutCardDownload, { LayoutCardDownloadData } from '../cardDownload/LayoutCardDownload';
import { colMagazineBrochuresProps, rowMagazineBrochuresProps } from 'src/utils/grid';
import { LayoutDynamicZoneComponentTypes } from 'src/modules/layout/components/dynamicZone/LayoutDynamicZone';
import styles from './LayoutCardsDownloads.module.scss';

export type LayoutCardsDownloadsData = {
  __typename: LayoutDynamicZoneComponentTypes.CardsDownloadsLayout;
  cards: LayoutCardDownloadData[];
  title_cards_downloads?: string;
  title?: string;
};

export type LayoutCardsDownloadsProps = {
  data: LayoutCardsDownloadsData;
};

const LayoutCardsDownloads = (props: LayoutCardsDownloadsProps) => {
  const { cards, title: _title, title_cards_downloads } = props.data;

  const title = title_cards_downloads || _title;

  return (
    <div>
      <h3 className={styles.title}>{title}</h3>
      <Row {...rowMagazineBrochuresProps}>
        {_.map(cards, (card) => (
          <Col {...colMagazineBrochuresProps}>
            <LayoutCardDownload data={card} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default LayoutCardsDownloads;
